import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../../components/Box';
import { Checkbox } from '../../../../components/Checkbox';
import { Dropdown } from '../../../../components/Dropdown';
import { ManualDropdown } from '../../../../components/ManualDropdown';
import { SlideSelect } from '../../../../components/SlideSelect';
import { Loader } from '../../../../components/Loader';
import { initiateNewCompnayValue, setNewCompanyValue, setNewCompanyAddress, deleteCompanyProperty } from '../../actions';
import { selectNewCompany, selectNewCompanyValue, selectCountries, selectCompanies, selectCompany } from '../../selectors';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { selectAddressTypes } from '../../../Address/selectors';
import {
  COMPANY_CURRENCY_OPTIONS,
  COMPANY_VINDAT_PAYMENTCONDITION,
  COMPANY_VINDAT_PAYMENTTYPE,
  REQUEST_COMPANY,
  BTW_COUNTRIES,
} from '../../constants';
import { selectWork } from '../../../Api/selectors';
import { getPropIdByName } from '../../../../utils/props';
import { IbanField } from '../../components/IbanField';
import { Permission } from '../../../../components/Permission';
import {
  COMPANY_EDIT_BTW_NUMBER,
  COMPANY_EDIT_IBAN,
  COMPANY_EDIT_COMPANY_FROM_EU,
  COMPANY_EDIT_CUSTOMERNUMBER,
  COMPANY_EDIT_VINDAT_PAYMENTCONDITION,
} from '../../../../components/Permission/constants';
import { SearchSelect } from '../../../../components/SearchSelectComponent';
import cn from 'classnames';
import CheckboxComponent from '../../../../containers/App/Components/Checkbox/Checkbox';
import styles from './Fields.module.css';
import { Button } from '../../../../components/Buttons';
import { Times } from '../../../../components/Icon';
import { makeSelectLocale } from '../../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../translate-countries';
import { switchCountryCodeInput } from '../../helpers';

dayjs.extend(customParseFormat);
const DROPDOWN_OPTIONS = {};

const MANUAL_DROPDOWN_OPTIONS = {
  company_from_eu: ['NL', 'EU', 'OUTSIDE_EU'],
  currency: COMPANY_CURRENCY_OPTIONS,
  vindat_paymenttype: COMPANY_VINDAT_PAYMENTTYPE,
  vindat_paymentcondition: COMPANY_VINDAT_PAYMENTCONDITION,
};

const Container = styled.div`
  max-width: 600px;
  .row-input {
    display: flex;
    flex-direction: row;
    .col-1 {
      flex-basis: 20%;
    }
    .col-2 {
      flex-basis: 75%;
    }
  }
  margin-bottom: 8px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }
`;
const InputCardWrapper = styled.div`
  width: 100%;
  .input-card-wrapper {
    > .decorated {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      gap: 8px;
    }
  }
`;

const STATE = {
  value: '',
  address: {},
};

/* eslint-disable react/prefer-stateless-function */
class CompanyCreateFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
    this.inputRef = createRef();
  }

  componentDidMount() {
    this.props.initiateValue();

    this.invoiceAddress && this.setState({ address: this.invoiceAddress });
  }

  componentDidUpdate(prevProps, prevState) {
    this.getAddressValues();
  }

  get countries() {
    return this.props.countries;
  }

  get locale() {
    return this.props.locale;
  }

  get company() {
    return this.props.companies.find(o => o.id == this.props.match.params.id);
  }

  get invoiceAddress() {
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'invoice')[0].id;
    return this.company?.addresses?.filter?.(a => a.typeId == addressTypeId)[0];
  }

  get btwNumberInputValue() {
    if (this.props.type !== 'BTW_number') return;
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    const isWithCode = options.find(o => this.props.value?.includes(o.value));
    // if (isWithCode) {
    // return this.props.value?.substring(2);
    // }
    return this.props.value;
  }

  deleteIbanProperties(type) {
    const typeId = getPropIdByName(this.props.company, type);
    if (!typeId) return;

    return this.props.deleteProperty(typeId, this.props.company.id, result => {
      if (result === true) {
        this.props.setValue('0', type);
      }
    });
  }

  getAddressValues() {
    const addressProps = { addressLine1: '', postcode: '', city: '', countryId: '' };

    for (let i in addressProps) {
      if (!this.props.values[i] && this.state.address[i]) {
        this.props.setValue(this.state.address[i], i);

        return this.setState((prev, props) => {
          return { ...prev, address: { ...prev.address, [`${i}`]: null } };
        });
      }
    }
  }

  isCheckbox() {
    return ['invoice_to_main_address'].indexOf(this.props.type) > -1;
  }

  isDropbox() {
    return this.props.type in DROPDOWN_OPTIONS || this.props.type === 'countryId';
  }

  isManualDropbox() {
    return this.props.type in MANUAL_DROPDOWN_OPTIONS;
  }

  isSlideSelect() {
    return ['second_iban'].indexOf(this.props.type) > -1;
  }

  wrap(children) {
    const containsCheckbox = element => {
      if (React.isValidElement(element) && element.props) {
        return typeof element.props.className === 'string' && element.props.className.includes('checkbox');
      }
      return false;
    };

    const isCheckboxComp = React.Children.toArray(children).some(child => containsCheckbox(child));
    if (this.isSlideSelect()) return this.slideSelect();
    switch (this.props.type) {
      default:
        if (isCheckboxComp) {
          return <div>{children}</div>;
        } else {
          return (
            <div>
              <label className="form-label">{this.formFieldLabel()}</label>
              {children}
            </div>
          );
        }
    }
  }

  formFieldLabel() {
    if (this.isCheckbox() || this.props.type == 'BTW_number') return null;
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  slideSelect() {
    return (
      <HBox vCenter>
        <p>{this.lbl(`vehicle.order.${this.props.type}`)}</p>
        <SlideSelect
          selected={this.props.value == 1}
          checkedLabel={this.lbl('YES')}
          notCheckedLabel={this.lbl('NO')}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';

            if (this.props.type === 'second_iban' && value == 0) {
              this.deleteIbanProperties('IBAN2');
              // this.deleteIbanProperties('IBAN2_approved_manual');
              // this.deleteIbanProperties('IBAN2_approved');

              this.props.setValue('', 'IBAN2');
              this.props.setValue('0', 'IBAN2_approved_manual');
              this.props.setValue('0', 'IBAN2_approved');
            }

            return this.props.setValue(value);
          }}
        />
      </HBox>
    );
  }

  dropdown() {
    const vals = DROPDOWN_OPTIONS[this.props.type];
    let options =
      this.props.type === 'countryId'
        ? this.countries.map(c => ({ value: c.id, label: translateCountry(c.name, this.locale) }))
        : vals.map(val => ({
            label: this.lbl(`company.property.${this.props.type}.${val}`),
            value: val,
          }));
    if (this.props.type == 'currency') {
      options = vals.map(currency => ({
        label: this.lbl(`company.property.${this.props.type}.${currency.name}`),
        value: currency.value,
      }));
    }
    const value = options.find(o => o.value == this.props.value);

    if (this.props.type === 'countryId') {
      return (
        <SearchSelect
          options={options}
          value={this.state.address?.countryId ? this.state.address.country.name : value}
          onChange={pair => {
            if (this.state.address?.countryId && this.props.type === 'countryId') {
              this.setState((prev, props) => {
                return { ...prev, address: { ...prev.address, countryId: '' } };
              });
            }
            this.props.setValue(pair.value);
          }}
        />
      );
    }
    return (
      <div className={cn(this.props.type === 'countryId' && 'dropdown-wrapper', styles.container)}>
        <Dropdown
          className={styles.dropdown}
          options={options}
          value={this.state.address?.countryId && this.props.type === 'countryId' ? this.state.address.country.name : value}
          onChange={pair => {
            if (this.state.address?.countryId && this.props.type === 'countryId') {
              this.setState((prev, props) => {
                return { ...prev, address: { ...prev.address, countryId: '' } };
              });
              return this.props.setValue(pair.value);
            }

            return this.props.setValue(pair.value);
          }}
        />
      </div>
    );
  }

  btwDropdown() {
    let options = BTW_COUNTRIES.map(c => ({ value: c.code, label: `${c.code}-${c.country}` }));
    let value = options.find(o => this.props.value?.includes(o.value));

    return (
      <div className={styles.container}>
        <SearchSelect
          options={options}
          value={value}
          onChange={pair => {
            if (value?.value) {
              this.props.setValue(`${pair.value}${this.props.values?.BTW_number?.substring(2)}`, 'BTW_number');

              switchCountryCodeInput(this.inputRef);
              return;
            }

            this.props.setValue(`${pair.value}${this.props.values?.BTW_number}`, 'BTW_number');
            switchCountryCodeInput(this.inputRef);
          }}
        />
      </div>
    );
  }

  manualDropdown() {
    const vals = MANUAL_DROPDOWN_OPTIONS[this.props.type];
    return (
      <ManualDropdown
        model={'company'}
        key={this.props.type}
        type={this.props.type}
        editable={!['company_from_eu', 'currency'].includes(this.props.type)}
        deletable={this.props.company && this.props.company[this.props.type]}
        options={vals}
        onChange={value => this.props.setValue(value)}
        onReset={() => this.props.setValue('')}
        onDeleteValue={value => {
          const propId = getPropIdByName(this.props.company, this.props.type);
          this.props.deleteProperty(propId, this.props.company.id, result => {
            if (result === true) {
              this.props.setValue('');
            }
          });
        }}
        onManual={value => {
          return this.props.setValue(value, this.props.type + '_manual');
        }}
      />
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.setAddress(this.state);
  }

  render() {
    if (this.props.work) return <Loader small />;
    if (!this.countries) return <Loader small />;
    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  renderField() {
    if (this.props.value === undefined) return null;

    if (this.isCheckbox()) {
      return (
        <CheckboxComponent
          key={this.props.type}
          className="checkbox"
          label={this.lbl(`vehicle.property.${this.props.type}`)}
          checked={this.props.value === '1'}
          onChange={() => {
            const value = this.props.value === '1' ? '0' : '1';
            return this.props.setValue(value);
          }}
        />
      );
    }

    if (this.isDropbox()) {
      return this.dropdown();
    }

    if (this.isManualDropbox()) {
      if (this.props.type === 'company_from_eu') {
        return (
          <Permission permission={COMPANY_EDIT_COMPANY_FROM_EU} proxy={this.props.value ?? '-'}>
            {this.manualDropdown()}
          </Permission>
        );
      }
      if (this.props.type === 'vindat_paymentcondition') {
        return (
          <Permission permission={COMPANY_EDIT_VINDAT_PAYMENTCONDITION} proxy={this.props.value ?? '-'}>
            {this.manualDropdown()}
          </Permission>
        );
      }
      return this.manualDropdown();
    }

    switch (this.props.type) {
      case 'IBAN':
        return (
          <VBox key={this.props.type}>
            <Permission permission={COMPANY_EDIT_IBAN} proxy={this.props.value ?? '-'}>
              <InputCardWrapper>
                <div className="input-card-wrapper">
                  <IbanField
                    cardWidth={{ maxWidth: '100%' }}
                    small
                    company={this.props.company}
                    value={this.props.value}
                    type={this.props.type}
                    onChange={evt => this.props.setValue(evt.target.value?.replace(/\s/g, ''))}
                  />
                </div>
              </InputCardWrapper>
            </Permission>
            <CheckboxComponent
              label={this.lbl('company.iban.checked_manual')}
              checked={this.props.company?.IBAN_approved_manual == '1'}
            />
          </VBox>
        );
      case 'IBAN2':
        return (
          <VBox key={this.props.type}>
            <Permission permission={COMPANY_EDIT_IBAN} proxy={this.props.value ?? '-'}>
              <InputCardWrapper>
                <div className="input-card-wrapper">
                  <IbanField
                    cardWidth={{ maxWidth: '100%' }}
                    small
                    company={this.props.company}
                    value={this.props.value}
                    type={this.props.type}
                    onChange={evt => this.props.setValue(evt.target.value?.replace(/\s/g, ''))}
                  />
                </div>
              </InputCardWrapper>
            </Permission>
            <CheckboxComponent
              label={this.lbl('company.iban.checked_manual')}
              checked={this.props.values?.IBAN2_approved_manual == '1'}
            />
          </VBox>
        );
      case 'BIC':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'bordercross':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'bordercross':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'BTW_number':
        return (
          <>
            <Permission permission={COMPANY_EDIT_BTW_NUMBER} proxy={this.props.value ?? '-'}>
              <HBox left vCenter gap={'12px'}>
                {this.btwDropdown()}

                <input
                  className="form-control"
                  ref={this.inputRef}
                  key={this.props.type}
                  value={this.props.values.BTW_number}
                  onChange={evt => {
                    this.props.setValue(evt.target.value);
                  }}
                  rightDecoration={
                    <Button
                      small
                      warning
                      disabled={this.props.disabled}
                      onClick={() => {
                        const propId = getPropIdByName(this.props.company, this.props.type);
                        this.props.deleteProperty(propId, this.props.company.id, result => {
                          if (result?.id) {
                            this.props.setValue('');
                          }
                        });
                      }}
                    >
                      <Times />
                    </Button>
                  }
                />
              </HBox>
            </Permission>
          </>
        );
      case 'payment_conditions':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'purchase_payment_term':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'payment_term':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'autotraderURL':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'autoscoutURL':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'credit_limit':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'customernumber':
        return (
          <Permission permission={COMPANY_EDIT_CUSTOMERNUMBER} proxy={this.props.value ?? '-'}>
            <input
              className="form-control"
              key={this.props.type}
              value={this.props.value}
              onChange={evt => this.props.setValue(evt.target.value)}
            />
          </Permission>
        );
      case 'addressLine1':
        return (
          <input
            className="form-control"
            placeholder={'Street Name and house number'}
            key={this.props.type}
            value={this.props.value ? this.props.value : this.state.address.addressLine1}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'postcode':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value ? this.props.value : this.state.address.postcode}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'city':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value ? this.props.value : this.state.address.city}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
    }
  }
}

CompanyCreateFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_COMPANY),
    value: selectNewCompanyValue(ownProps.type),
    values: selectNewCompany(),
    company: selectCompany(ownProps.company_id),
    countries: selectCountries(),
    companies: selectCompanies(),
    addressTypes: selectAddressTypes(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewCompanyValue(name, value));
    },
    setAddress(address) {
      dispatch(setNewCompanyAddress(address));
    },
    deleteProperty(propertyId, companyId, callback) {
      dispatch(deleteCompanyProperty(propertyId, companyId, callback));
    },
    initiateValue() {
      dispatch(initiateNewCompnayValue(ownProps.type));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyCreateField = compose(withConnect, withRouter)(CompanyCreateFieldComp);
